import Button from "./Button";
import SingleInfluencerCircle from "./SingleInfluencersCircles";

const InfluencerCircles = () => {
  return (
    <div className="influencer-wrapper md:max-w-[1140px] md:mx-auto xs:px-0">
      <div className="title text-[22px] text-[#414141] px-4">
        <h2 className="inline-block before:content-[''] before:block before:w-1/2 before:border before:border-[#414141]">
          beslenme uzmanları
        </h2>
      </div>
      <div className="influencer-list overflow-auto pt-12">
        <ul className="flex md:justify-center xs:flex-nowrap md:flex-wrap">
          {Array(11)
            .fill(true)
            .map((li, index) => {
              return <SingleInfluencerCircle key={index} />;
            })}
        </ul>
      </div>
      <div className="button flex justify-center">
        <Button isHovered>Tümünü görüntüle</Button>
      </div>
    </div>
  );
};

export default InfluencerCircles;
